import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import useCurrentLang from '@/hooks/apps/useCurrentLang';

import Area from '@/components/apps/layouts/shared/Area';
import SectionTitle from '@/components/apps/ui/title/SectionTitle';
import TransCustom from '@/components/apps/ui/transCustom/TransCustom';
import { AniSlideUp } from '@/components/shared/animations/basic';

import IndustrialDashboardShowcase from './IndustrialDashboardShowcase';

export default function IndustrialSystemSection() {
  const { t } = useTranslation('common');
  const lang = useCurrentLang();

  const texts = [
    {
      title: t('실시간 AI 분석 기능'),
      description: (
        <TransCustom i18nKey="공장 현장의 노이즈에 최적화된 AI 모델이 탑재되어 실시간으로 분석해 알림을 주고 있어요." />
      ),
    },
    {
      title: t('PLC, MES 연동'),
      description: (
        <TransCustom i18nKey="SIEMENS, MITSUBISHI 등 다양한 공장 PLC 신호를 바탕으로 빠르고 정확한 분석이 가능해요." />
      ),
    },
    {
      title: t('AI 분석 데이터 관리'),
      description: (
        <TransCustom i18nKey="AI가 일관된 기준으로 품질을 분석하고, 그 결과를 데이터로 기록·관리할 수 있어요." />
      ),
    },
  ];

  return (
    <section
      className="pt-[clamp(100px,10.417vw,200px)] lg:bg-[url('/images/apps/solution/safety/sec_03_bg_01.png')] lg:bg-contain lg:bg-top lg:bg-no-repeat"
      data-analytics-section="monitoring_system"
    >
      <Area>
        <SectionTitle
          color="lighter"
          title={t('모니터링 시스템')}
          description={t(
            'Listen AI Industrial 솔루션의 검사 현황을 실시간으로 확인할 수 있는 대시보드 화면',
          )}
        />
        <div className="mt-[40px] lg:mt-[clamp(40px,6.667vw,80px)]">
          <IndustrialDashboardShowcase lang={lang} t={t} />
        </div>

        <AniSlideUp>
          <ul className="pt-[48px]">
            {texts.map((text, index) => (
              // 원본은 `&:not(:last-child)` 에만 border-bottom 을 걸었다. not-last: 변형으로 그대로 옮긴다.
              // padding-inline 은 base/lg 모두 0 이라 px-0 하나만 내보낸다(같은 속성 중복 금지).
              <li
                key={index}
                className="px-0 py-[24px] not-last:border-b not-last:border-b-apps-brandGray50 lg:grid lg:grid-cols-[calc(484/1480*100%)_calc(976/1480*100%)] lg:gap-[20px] lg:py-[clamp(24px,3.333vw,40px)]"
              >
                <h3 className="text-[22px] font-bold leading-[160%] tracking-[-0.44px] lg:text-[clamp(22px,2.333vw,28px)] lg:leading-[140%] lg:tracking-[-0.56px]">
                  {text.title}
                </h3>
                <p className="mt-[4px] text-[16px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray600 lg:text-[18px] lg:leading-[160%] lg:tracking-[-0.36px]">
                  {text.description}
                </p>
              </li>
            ))}
          </ul>
        </AniSlideUp>
      </Area>
    </section>
  );
}
